import * as React from 'react';
import styles from './badge-list.scss';
import { toHex } from 'ui/common/hex-converter';
import { Tooltip } from 'ui/common/tooltip/tooltip';

interface BadgelistItemProps{
  index?: number;
  value?: number | string;
  tooltip?: string;
  classNames?: string;
  backgroundColor?: number;
  checkIcon?: boolean;
}

const Circle = (props: BadgelistItemProps & {useNestedIndicator?:boolean}) =>  {
  const {index, classNames, useNestedIndicator, backgroundColor, checkIcon = true} = props;

  return (Number(props.value) >= 0 ?
            <div className={classNames} key={index}>
              <svg className={styles.countCircle} viewBox="0 0 50 50" preserveAspectRatio="xMinYMin meet">
                <circle cx="25" cy="25" r="23" fill="white" stroke="#CBD5E8" strokeWidth="2"/>
                <text x="25" y="33" fontSize="25" fill="black">{props.value}</text>
                {
                  useNestedIndicator && backgroundColor &&
                    <circle cx="40" cy="40" r="8" fill={backgroundColor && toHex(backgroundColor)} stroke="white"
                      strokeWidth="2"/>
                }
              </svg>
              {checkIcon && <svg className="green-check-icon" viewBox="-17351.9 -19165 13.135 10">
                <path fill="#36842d"
                  d="M266.279,882.51l7.91-7.91,1.045,1.045-8.955,8.955-4.179-4.179,1.045-1.045Z"
                  transform="translate(-17614 -20039.6)"/>
              </svg>}
            </div> : null
          );
};

export class BadgeList extends React.PureComponent<BadgeListProps> {
  private infoText = (items: BadgelistItemProps[]) => {
    return items.map(item => `${Number(item.value) >= 0 ? item.value : ''} ${item.tooltip}`).join('\n');
  };

  private circleItems = (items: BadgelistItemProps[]) => {
    return items.map((item, index) => <Circle key={index} classNames={this.props.className} {...item} {...this.props} />);
  };

  public render() {
    const {
      title,
      icon,
      valueItems,
      narrow = true,
      className,
      portalTarget
    } = this.props;
    return (
        <Tooltip className={`${styles.tooltipOverwrite} ${className}`} title={this.infoText(valueItems)} 
          delayed={true} center={true} narrow={narrow} portalTarget={portalTarget}>
          <div className={`${styles.badgelistWrapper} badge-list-wrapper`}>
            {title && <label className={styles.label}>{title}</label>}
            <div className="badge-illustration">
              {icon}
              <div className={`${styles.items} ${valueItems && valueItems.length === 1 ? styles.single : ''}`}>
                {!!valueItems && this.circleItems(valueItems)}
              </div>
            </div>
          </div>
        </Tooltip>
    );
  }
}
export interface BadgeListProps {
  icon: any;
  valueItems: BadgelistItemProps[];
  title?: string;
  useNestedIndicator?: boolean;
  narrow?: boolean;
  checkIcon?: boolean;
  className?: string;
  textLabel?: string;
  portalTarget?: HTMLElement;
}
